import { DealerLayout } from "@/components/shared/DealerLayout";
import ChatCenter from "@/components/shared/ChatCenter";

export default function DealerChat() {
  return (
    <DealerLayout title="Communication Center" breadcrumb="Chat">
      <ChatCenter isAdmin={false} />
    </DealerLayout>
  );
}
